import { Button, Grid, Typography } from '@oresundsbron/bridge-ui';
import { EmailIcon } from '@oresundsbron/icons';
import { useTranslation } from 'next-i18next';
import { ChangeEvent, FormEvent, useState } from 'react';
import { useSubscribeToTrafficInformation } from '~/hooks/TrafficInformation/useSubscribeToTrafficInformation';
import {
  ResponseBanner,
  ResponseStatus,
} from '../../pages/traffic-information/ResponseBanner';

const SubscribeToTrafficInformation = () => {
  const [inputValue, setInputValue] = useState('');
  const [loading, SetLoading] = useState(false);
  const [status, setStatus] = useState<ResponseStatus>(ResponseStatus.hide);

  const { t } = useTranslation(['trafficInformation', 'common'], {
    nsMode: 'fallback',
  });

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
    setStatus(ResponseStatus.hide);
  };

  const onSuccess = () => {
    SetLoading(false);
    setStatus(ResponseStatus.success);
    setInputValue('');
  };

  const onError = () => {
    SetLoading(false);
    setStatus(ResponseStatus.error);
  };

  const subscribe = useSubscribeToTrafficInformation({ onSuccess, onError });

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    SetLoading(true);
    e.preventDefault();
    setStatus(ResponseStatus.hide);
    subscribe(inputValue, 'subscribe');
  };

  const successText = t('subscribe.emailSent');
  const errorText = t('general.error');

  return (
    <>
      <div className="bg-primary mt-8 flex flex-col justify-center p-6">
        <Grid className="col-start-2 self-center">
          <Typography
            as="h3"
            intent="title"
            size="lg"
            className="col-span-full"
          >
            {t('subscribe.title')}
          </Typography>
          <Typography className="col-span-full">
            {t('subscribe.description')}
          </Typography>
        </Grid>
        <div className="mx-auto max-w-prose">
          <div className="mt-10 flex min-w-full items-center justify-center">
            <div className="min-w-full">
              <div className="mb-4 flex items-center">
                <EmailIcon
                  className="mr-4 fill-blue-900"
                  height="1.5em"
                  width="1.5em"
                />
                <span>E-mail</span>
              </div>
              <form
                onSubmit={handleSubmit}
                className="flex flex-col justify-between gap-4 sm:flex-row"
              >
                <input
                  className="w-full rounded-md border border-stone-600 bg-transparent p-2"
                  type="email"
                  placeholder="E-post"
                  value={inputValue}
                  onChange={handleInputChange}
                  required
                />
                <Button
                  type="submit"
                  className="flex justify-center"
                  disabled={loading || status === ResponseStatus.success}
                >
                  {t('subscribe.subscribeBtn')}
                </Button>
              </form>
            </div>
          </div>
          <ResponseBanner {...{ status, successText, errorText }} />
        </div>
      </div>
    </>
  );
};

export default SubscribeToTrafficInformation;
